/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface GuidItemGroupDto
 */
export interface GuidItemGroupDto {
    /**
     * 
     * @type {string}
     * @memberof GuidItemGroupDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuidItemGroupDto
     */
    items?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GuidItemGroupDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuidItemGroupDto
     */
    $type?: GuidItemGroupDtoTypeEnum;
}


/**
 * @export
 */
export const GuidItemGroupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoGuidItemGroupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.GuidItemGroupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GuidItemGroupDtoTypeEnum = typeof GuidItemGroupDtoTypeEnum[keyof typeof GuidItemGroupDtoTypeEnum];


/**
 * Check if a given object implements the GuidItemGroupDto interface.
 */
export function instanceOfGuidItemGroupDto(value?: unknown): value is GuidItemGroupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GuidItemGroupDtoTypeEnum)[0];
}

export function GuidItemGroupDtoFromJSON(json: any): GuidItemGroupDto {
    return GuidItemGroupDtoFromJSONTyped(json, false);
}

export function GuidItemGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidItemGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'items': !exists(json, 'items') ? undefined : json['items'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GuidItemGroupDtoToJSON(value?: GuidItemGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'items': value.items,
        'groupHash': value.groupHash,
        '$type': value.$type,
    });
}

